import { j as t } from "../../../../../../../../../../jsx-runtime.BREq8dyb.js";
import { faSquare as d, faBinary as m } from "@fortawesome/pro-regular-svg-icons";
import { faSquareCheck as n } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon as r } from "@fortawesome/react-fontawesome";
import { Tooltip as p, Button as l } from "@mui/joy";
import { memo as u } from "react";
import "../../../../../../../../contexts/DatasetContext/DatasetContext.js";
import "../../../../../../../../contexts/FeatureContext/FeatureContext.js";
import "../../../../../../../../contexts/FileContext/FileContext.js";
import "../../../../../../../../contexts/IntrospectionContext/IntrospectionContext.js";
import "../../../../../../../../contexts/NavigatorContext/NavigatorContext.js";
import { useOptions as c } from "../../../../../../../../contexts/OptionsContext/OptionsContext.js";
import "../../../../../../../../contexts/SchemaContext/SchemaContext.js";
import "../../../../../../../../contexts/TypificationContext/TypificationContext.js";
import "../../../../../../../../contexts/WorkerContext/WorkerContext.js";
const f = u(({
  columnIndex: i
}) => {
  const {
    hashedColumns: o,
    setHashedColumns: s
  } = c();
  return /* @__PURE__ */ t.jsx(p, { disableFocusListener: !0, disableTouchListener: !0, title: /* @__PURE__ */ t.jsxs("div", { children: [
    /* @__PURE__ */ t.jsx("div", { children: "Hash this column" }),
    /* @__PURE__ */ t.jsx("div", { children: "When checked, the values of this column will be hashed before upload." }),
    /* @__PURE__ */ t.jsx("div", { children: "When not checked, it assumes this column already has values hashed." })
  ] }), children: /* @__PURE__ */ t.jsxs(l, { "aria-pressed": o.includes(i) ? "true" : "false", "data-testid": `hash-with-toggle-button-${i}`, onClick: (a) => {
    s((e) => e.includes(i) ? e.filter((h) => h !== i) : [...e, i]), a.stopPropagation();
  }, sx: {
    gap: "0.025rem",
    minHeight: "auto",
    padding: "4px"
  }, variant: "outlined", children: [
    /* @__PURE__ */ t.jsx(r, { fixedWidth: !0, icon: o.includes(i) ? n : d }),
    /* @__PURE__ */ t.jsx(r, { fixedWidth: !0, icon: m })
  ] }) });
});
f.displayName = "HashToggleButton";
export {
  f as default
};
//# sourceMappingURL=HashToggleButton.js.map
